import { pxToRem } from 'styles/functions'

// same client as lacleamy
const Theme = {
    body_background_color: '#9bb395',
    header_border_color: 'transparent',

    logo_image_url: 'demoofficetourisme.png',
    header_full_height: true,

    token_hidden: true,

    number_hidden: true,

    button_color: '#d55142',
    button_hover_color: 'white',
 
    button_text_size: 16,
    button_text_lineheight: 24,
    button_text_weight: 700,
    button_border_width: 1,
    button_radius: 10,
   
    text_font: `Raleway sans serif`,
    text_color: '#285D51',
    text_weight: '300',

    title_font: `Merriweather`,
    title_size: 28,
    title_lineheight: 38,
    title_color: '#285D51',
    title_weight: 800,
    title_margin: `${pxToRem(10)} 0 ${pxToRem(10)} ${pxToRem(10)} `,

    subtitle_fontL:'Merriweather',
    subtitle_color: '#285D51',
    subtitle_size: 24,
    subtitle_lineheight: 32,
    subtitle_weight: 800,

    button_half_border_color: '#285D51',

    separator_color: '#285D51',

    footer_border_color: 'transparent',
}

export default Theme
